import Logo from '../assets/images/techp-logo.png';
import spashLogo from '../assets/images/logo.png';
import Nothing from '../assets/images/nothing.png';
import PearlnetLogo from '../assets/images/pearlnet.png';
import notification from '../assets/images/notification.png';
import login from '../assets/images/login.png';
import homepage from '../assets/images/homepage.png';
import employee from '../assets/images/employee.png';
import summary from '../assets/images/summary.png';
import summarybutton from '../assets/images/summarybutton.png';
import summaryone from '../assets/images/summaryone.png';
import blog from '../assets/images/blog.png';
import buz from '../assets/images/buz.png';
import implink from '../assets/images/implink.png';
import newRow from '../assets/images/new_row.png';
import WeeklyReport from '../assets/images/weekly_report.png';
import Project from '../assets/images/project.png';
import MyTeam from '../assets/images/myTeme.png';
import Month from '../assets/images/months.png';
import comment from '../assets/images/comment.png';
import comment2 from '../assets/images/comment2.png';
import comment3 from '../assets/images/comment3.png';
import ComingSoon from '../assets/images/Coming-Soon.png';


export default {
    LOGO: Logo,
    SPLASH_LOGO: spashLogo,
    NOTHING_IMG: Nothing,
    PEARLNET_LOGO: PearlnetLogo,
    NOTIFICATION: notification,
    LOGIN: login,
    HOMEPAGE:homepage,
    EMPLOYEE:employee,
    SUMMARY:summary,
    SUMMARYBUTTON:summarybutton,
    SUMMARYONE:summaryone,
    BLOG:blog,
    BUZ:buz,
    IMPLINK:implink,
    NEWROW:newRow,
    WEEKLYREPORT:WeeklyReport,
    PROJECT:Project,
    MYTEAM:MyTeam,
    MONTH:Month,
    COMMENT:comment,
    COMMENT2:comment2,
    COMMENT3:comment3,
		COMINGSOON:ComingSoon
} as const;
